import "./SamparkPage.css";

function SamparkPage() {
  return (
    <div className="sampark-page">
      {/* This image is for the background, */}
      <img
        src="assets/images/logo.png"
        alt="company logo"
        className="sampark-page__bg-image"
      />

      <div className="sampark-page__content">
        <h3 className="sampark-page__tittle">सम्पर्क</h3>
        <p className="sampark-page__para">महाकाली नगरपालिका वडा नं. ५</p>
        <p className="sampark-page__para">
          फोन: ९८१२३४५६७८ ९८१२३२४५३२ <br></br>०९१- ९८१२३३ ०९१-०२९३२११{" "}
        </p>
        <p className="sampark-page__para">Email: swalabmhi12@gmail.com</p>
        <div className="sampark-page__image-box">
          <img
            className="sampark-page__image"
            src="assets/images/facebook.webp"
            alt="Facebook logo"
          />
        </div>
      </div>
    </div>
  );
}

export default SamparkPage;
